import { Tooltip } from '@mui/material';

export interface BatteryInfo {
    chargeLevel: number;
    isCharging: boolean;
}

interface BatteryLevelProps {
    battery: BatteryInfo;
    size?: number;
}

export default function BatteryLevel({ battery, size = 32 }: BatteryLevelProps) {
    const { chargeLevel, isCharging } = battery;
    if (chargeLevel > 40) return null;

    const clampedLevel = Math.min(100, Math.max(0, chargeLevel));
    const color = 'currentColor';

    const bodyW = size * 0.72;
    const bodyH = size * 0.42;
    const bodyX = 0;
    const bodyY = (size - bodyH) / 2;
    const radius = size * 0.06;

    const capW = size * 0.06;
    const capH = bodyH * 0.45;
    const capX = bodyW;
    const capY = bodyY + (bodyH - capH) / 2;

    const border = size * 0.05;
    const fillMaxW = bodyW - border * 2;
    const fillH = bodyH - border * 2;
    const fillX = bodyX + border;
    const fillY = bodyY + border;
    const fillW = (fillMaxW * clampedLevel) / 100;

    const svgW = bodyW + capW + size * 0.02;

    const tooltipLabel = `Заряд: ${clampedLevel}%${isCharging ? ' · Заряжается' : ''}`;

    // Lightning bolt centered on the battery body
    const boltCX = bodyW / 2;
    const boltCY = size / 2;
    const boltH = bodyH * 0.7;
    const boltW = boltH * 0.45;
    const boltPoints = [
        `${boltCX + boltW * 0.15},${boltCY - boltH / 2}`,
        `${boltCX - boltW * 0.1},${boltCY + boltH * 0.05}`,
        `${boltCX + boltW * 0.12},${boltCY + boltH * 0.05}`,
        `${boltCX - boltW * 0.15},${boltCY + boltH / 2}`,
        `${boltCX + boltW * 0.1},${boltCY - boltH * 0.05}`,
        `${boltCX - boltW * 0.12},${boltCY - boltH * 0.05}`,
    ].join(' ');

    return (
        <Tooltip title={tooltipLabel} arrow>
            <svg
                width={svgW}
                height={size}
                viewBox={`0 0 ${svgW} ${size}`}
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'block', cursor: 'default' }}
            >
                {/* Battery body outline */}
                <rect
                    x={bodyX}
                    y={bodyY}
                    width={bodyW}
                    height={bodyH}
                    rx={radius}
                    ry={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth={border}
                />

                {/* Battery cap */}
                <rect x={capX} y={capY} width={capW} height={capH} rx={size * 0.02} ry={size * 0.02} fill={color} />

                {/* Charge fill */}
                {fillW > 0 && (
                    <rect
                        x={fillX}
                        y={fillY}
                        width={fillW}
                        height={fillH}
                        rx={radius * 0.5}
                        ry={radius * 0.5}
                        fill={color}
                        opacity={0.85}
                    />
                )}

                {/* Lightning bolt when charging */}
                {isCharging && <polygon points={boltPoints} fill="#fff" opacity={0.9} />}
            </svg>
        </Tooltip>
    );
}
